<template>
  <footer class="row align-middle hkld-footer">
    <div
      class="column align-right hkld-footer__copyright"
      v-html="footerHml"
    />
    <!-- HKLDPMSR-7921 Can be removed in R4 release -->
    <!-- <a id="footer-logo">
      <img v-if="showLoggedInContent" v-region-img-src="'hkld-logo-footer.png'" class="hkld-logo" alt="Hongkong Land" />
      <img v-if="!showLoggedInContent" src="/hkld-logo-footer.png" class="hkld-logo" alt="Hongkong Land" />
    </a> -->
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import { regionNames } from '@/utils/consts'
import useLoginStatus from './useLoginStatus'

export default {
  name: 'StickyFooter',
  setup () {
    const { showLoggedInContent } = useLoginStatus()
    return { showLoggedInContent }
  },
  computed: {
    ...mapGetters('regions', ['currentRegion', 'publicPathLastSelectedRegion']),
    regionName () {
      return (this.showLoggedInContent ? this.currentRegion.name : this.publicPathLastSelectedRegion.name) || regionNames.HK
    },
    footerHml () {
      const currentYear = new Date().getFullYear()
      return this.$t(`pmsrFooter.${this.regionName}`, {currentYear})
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings';
.hkld-footer__copyright{
  display: flex;
  justify-content: flex-start;
  padding: 0 24px;
  .copyright {
    flex-shrink: 0;
  }
  .company-subsidiary {
    flex-grow: 1;
  }
}

footer {
  color: $sticky-footer-color;
  min-height: $sticky-footer-height;
  height: $sticky-footer-height;
  background: $sticky-footer-bg;
  bottom: 0;
}

.row{
  width: 100%;
  max-width: 100%;
}

.hkld-footer {
  font-size: 12px;
  font-family: Verdana;
  color: white;
  #logo {
    cursor: default;
  }
  .hkld-logo {
    height: 25px;
    position: absolute;
    right: 20px;
    transform: translateY(-50%);
  }
}

.hkld-footer:first-child {
  margin-left: 0;
}

.hkld-footer__nav {
  float: left;
  list-style: none;
  padding-left: 0px;
  margin: 0;

  li {
    border-right: 1px solid #27557b;
    display: inline-block;
    padding-left: 20px;
    padding-right: 20px;

    &:first-child {
      padding-left: 0px;
    }

    &:last-child {
      border: 0px;
    }

    a {
      color: white;
      text-decoration: none;
    }
  }
}
</style>
